module.exports = __webpack_public_path__ + "static/media/SmallIntestine.a3b3e8dd.ogg";